import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Contact API
export const contactAPI = {
  submitContact: async (contactData) => {
    try {
      const response = await api.post('/contact', contactData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Newsletter API
export const newsletterAPI = {
  subscribe: async (email, source = 'website') => {
    try {
      const response = await api.post('/newsletter', { email, source });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Portfolio API
export const portfolioAPI = {
  getPortfolio: async (category = null, limit = 10) => {
    try {
      const params = { limit };
      if (category && category !== 'All') {
        params.category = category;
      }
      const response = await api.get('/portfolio', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  getCategories: async () => {
    try {
      const response = await api.get('/portfolio/categories');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Blog API
export const blogAPI = {
  getPosts: async (category = null, search = null, limit = 10, skip = 0) => {
    try {
      const params = { limit, skip };
      if (category && category !== 'All') {
        params.category = category;
      }
      if (search) {
        params.search = search;
      }
      const response = await api.get('/blog', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  getPost: async (postId) => {
    try {
      const response = await api.get(`/blog/${postId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  
  getCategories: async () => {
    try {
      const response = await api.get('/blog/categories');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Services API
export const servicesAPI = {
  getServices: async () => {
    try {
      const response = await api.get('/services');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Testimonials API
export const testimonialsAPI = {
  getTestimonials: async (limit = 10) => {
    try {
      const response = await api.get('/testimonials', { params: { limit } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Profile API
export const profileAPI = {
  getProfile: async () => {
    try {
      const response = await api.get('/profile');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

// Health check
export const healthAPI = {
  check: async () => {
    try {
      const response = await api.get('/health');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default api;